<template>
    <div>
        <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
                <v-btn class="mr-1" small color="primary" dark v-on="{...tooltip}"
                    v-on:click="()=>dialog=!dialog"
                >
                    <v-icon>mdi-swap-horizontal</v-icon>
                </v-btn>
            </template>
            <span>{{$t('referenceBooks.devices.ChangeBranch')}}</span>
        </v-tooltip>
        <DragForm
                v-model="dialog"
        >
            <v-card width="800">
                <v-card-title>
                    <span class="headline">{{$t('referenceBooks.devices.ChangeBranch')}}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>

                            <v-col cols="12" sm="12" md="12">
                                {{$t('referenceBooks.banks.Name')}} : {{device.deviceName}}
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                {{$t('referenceBooks.branches.Name')}} : {{device.branchName}}
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-select
                                        :label="$t('Branches')"
                                        :items="branchesExceptCurrentBranch"
                                        v-model="selectedBranch"
                                        :item-value="'branchId'"
                                        :item-text="'name'"
                                        :key="'branchId'"
                                        return-object
                                />

                            </v-col>

                        </v-row>
                    </v-container>
                    <v-row v-if="actionPerformed">
                        <ActionResult :success="success"/>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">{{$t('Close')}}</v-btn>
                    <v-btn color="blue darken-1" text @click="save">{{$t('Save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </DragForm>
    </div>
</template>

<script>
import ActionResult from '@/components/ActionResult';
import {notifyError, notifySuccess} from '@/services/notifications';
import DragForm from '@/components/Forms/DragForm.vue';

export default {
  name: 'PinDeviceToAnotherBranch',
  components: {DragForm, ActionResult},
  props: {
    device: {
      type: Object
    },

  },
  data() {
    return {
      actionPerformed: false,
      success: false,
      error: false,
      dialog: false,
      selectedBranch: null,
      branches: []
    };
  },
  computed: {
    branchesExceptCurrentBranch(){
      return this.branches.filter(b => b.branchId !== this.device.branchId);
    }
  },
  async mounted(){
    await this.$axios.branches.getByBanksArrayForDevices([this.device.bankId])
      .then(response => response.data)
      .then(json => this.branches = json)
      .catch(error => console.error(error));
  },
  methods: {
    close() {
      this.dialog = false;
      this.$emit('close');
    },
    async save() {
      const data = [this.selectedBranch.branchId];

      await this.$axios
        .devices.changeBranch(
          this.device.deviceId,
          data
        )
        .then(response => {
          this.success = true;
          notifySuccess('', this.$t('Messages.DeviceWasRepinnedToBranch', [this.device.deviceName, this.selectedBranch.name]));
          this.$emit('attach', response.status, this.device.deviceId);
          this.close();
        })
        .catch(error => {
          this.success = false;
          notifyError('', this.$t('Error'));
          console.error(error);
          this.$emit('error', error);
        });
      this.actionPerformed = true;

    },
    async getProducts() {

      await this.$axios.products.getAvailableForDevice(this.device.deviceId)
        .then(response => response.data)
        .then(json => this.products = json)
        .catch(error => console.error(error));

    },

  },

};
</script>